module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-modal__showcase"><div class="ggs-gallery-modal__showcase__content"> ' +
((__t = ( ejs.partialContent )) == null ? '' : __t) +
' </div><div class="ggs-gallery-modal__showcase__icon" roe-show-emitter=":: $ctrl.hasShowcaseIcon" roe-show="$ctrl.hasShowcaseIcon()" roe-class-emitter=":: $ctrl.isTinyLayout" roe-class="{\n      \'ggs-gallery-modal__showcase__icon_cmmn\': !$ctrl.isTinyLayout(),\n      \'ggs-gallery-modal__showcase__icon_tiny\': $ctrl.isTinyLayout()\n    }" ng-class="{\n      \'ggs-gallery-modal__showcase__icon_show\': $ctrl.showsShowcaseIcon\n    }"> ' +
((__t = ( ejs.partialIcon )) == null ? '' : __t) +
' </div></div>';
return __p
}